import { Box, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { colors } from 'src/utils/colors';

interface ISmallHeading {
	text: string;
	warningText?: string;
	info?: boolean;
}

export const SmallHeading: FC<ISmallHeading> = ({ text, warningText, info = false }) => {
	return (
		<Box
			display="flex"
			alignItems="center"
			gridGap="10px"
			fontSize="14px"
			color="white"
		>
			{text}
			{warningText && (
				<Text
					fontSize="12px"
					color={info ? colors.gray : colors.primary}
				>
					{warningText}
				</Text>
			)}
		</Box>
	);
};
